module.exports = __webpack_public_path__ + "img/31_Sargo (A.scapularis).86c535ca.png";